import * as yup from 'yup';

export const userProfileUpdateSignUpSchema = yup.object().shape({
    // Full Name validation
    name: yup
        .string()
        .required('Full Name is required')
        .min(3, 'Full Name must be at least 3 characters long')
        .max(50, 'Full Name cannot exceed 50 characters'),

    // Social Security Number validation (exactly 4 digits)
    ss_number: yup
        .string()
        .required('Social Security Number is required'),

    // About Yourself validation (optional, max 300 characters)
    about: yup
        .string()
        .max(300, 'About Yourself cannot exceed 300 characters')
        .notRequired(),  // Not required, but validation is still applied

    // Profile Picture validation (required, max size 5MB, jpeg/png/jpg formats)
    // profilePicture: yup
    //     .mixed()
    //     .test('required', 'Profile Picture is required', (value) => value !== null)  // Check if a file is uploaded
    //     .test('fileSize', 'File size is too large', (value) => {
    //         return value && value.size <= 5 * 1024 * 1024; // Max 5MB
    //     })
    //     .test('fileType', 'Unsupported file format', (value) => {
    //         return value && ['image/jpeg', 'image/png', 'image/jpg'].includes(value.type); // Only jpeg, png, jpg
    //     }),

});
